import { TPresetOffer } from "@api-types/bet-booster/PresetOffer";
import { EventOffer } from "@gp/offer";
import { NameProvider } from "@gp/utility";
import { format } from "@utils/format";
import { DateTime } from "luxon";

export class MultiOffers {
	bettingOfferId: string;
	bettingOfferKeyId: string;
	bettingTypeId: string;
	bettingTypeTip: string;
	eventId: string;
	isLocked: boolean;
	playerId: string | null;
	specifier: null | { player: string };
	sportData: any;
	teamId: string | null;
	value: number;
	playerFirstName: string;
	playerLastName: string;
	nameProvider: NameProvider;

	constructor(offer: TPresetOffer) {
		Object.assign(this, offer);
		this.nameProvider = new NameProvider();
	}

	get timeString() {
		if (this.sportData?.startTime) {
			return DateTime.fromISO(this.sportData?.startTime).toFormat(
				"dd.MM. HH:mm"
			);
		}
	}

	get teamOneString() {
		return format.formatTeamName(
			this.sportData?.teamOneName,
			this.sportData?.teamOneGender,
			this.sportData?.eventType
		);
	}

	get teamTwoString() {
		return format.formatTeamName(
			this.sportData?.teamTwoName,
			this.sportData?.teamTwoGender,
			this.sportData?.eventType
		);
	}

	scorePerPeriodString(liveResult?: EventOffer | null) {
		const sportData = liveResult || this.sportData;
		if (sportData?.result?.scorePerPeriod == null) {
			return "";
		}

		const periodScores = sportData?.result.scorePerPeriod
			.reduce((acc: string[], value: { home: number; away: number }) => {
				acc.push(`${value.home || 0}:${value.away || 0}`);
				return acc;
			}, [])
			.join("; ");

		return `(${periodScores})`;
	}

	/* get scorePerPeriodAtBetTimeString() {
		if (this.currentResult?.scorePerPeriod == null) {
			return "";
		}

		return this.currentResult.scorePerPeriod
			.reduce((acc: string[], value: { home: number; away: number }) => {
				acc.push(`(${value.home || 0}:${value.away || 0})`);
				return acc;
			}, [])
			.join(" ");
	}
 */
	formattedCurrentResult(liveResult: EventOffer | null) {
		const sportData = liveResult || this.sportData;
		if (sportData?.result?.fullTimeScore != null) {
			return `${sportData?.result.fullTimeScore.home || 0}:${
				sportData?.result.fullTimeScore.away || 0
			}`;
		}

		if (sportData?.result?.currentScore != null) {
			return `${sportData.result.currentScore.home || 0}:${
				sportData.result.currentScore.away || 0
			}`;
		}

		return "";
	}

	/* 	get formattedResultAtBetTime() {
		if (this.currentResult?.currentScore != null) {
			return `${this.currentResult.currentScore.home || 0}:${
				this.currentResult.currentScore.away || 0
			}`;
		}

		return "";
	} */

	get formattedBettingType() {
		const bettingType = this.nameProvider.getName(
			this.sportData?.bettingTypeNameForBettingSlip,
			this.formattedOfferSpecifier
		);
		return bettingType;
	}

	get formattedBettingTypeTip() {
		const bettingTypeTip = this.nameProvider.getName(
			this.bettingTypeTip,
			this.formattedOfferSpecifier
		);
		return bettingTypeTip;
	}

	get formattedOfferSpecifier() {
		return {
			competitor1: this.sportData?.teamOneName,
			competitor2: this.sportData?.teamTwoName,
			...this.specifier,
		};
	}
}
